import React, { useEffect, useRef, useState } from "react"
import { Input, Progress } from "reactstrap"
import upload from "../../assets/images/icons/upload.svg"
import deleteIcon from "../../assets/images/icons/delete-red1.svg"
import pdfIcon from "../../assets/images/icons/file-type.svg"
import toast from "react-hot-toast"
import { APICore } from "helpers/api/apiCore"
import { fileSize } from "helpers/common"
import { useLogout } from "hooks/useLogout"
import checkboxIcon from "../../assets/images/icons/checkbox.svg"

const api = new APICore()

const PdfUpload = ({ onUploadSuccess }) => {
  const [progress, setProgress] = useState(0)
  const [files, setFiles] = useState([])
  const fileRef = useRef(null)
  const logout = useLogout()

  const onUploadFile = async (file) => {
    try {
      if (file.type !== "application/pdf") {
        toast.error("Please upload PDF files only.")
        return
      }

      // if (file.size > 10 * 1024 * 1024) {
      //   toast.error("File size must be under 10MB.")
      //   return
      // }

      const { data } = await api.uploadFile("/common/file", { file }, (e) =>
        setProgress(Math.round((e.loaded * 100) / e.total))
      )

      setFiles((prev) =>
        prev.map((item) =>
          item.isUploading
            ? {
                ...item,
                file_name: data.data.filename,
                isUploading: false,
              }
            : item
        )
      )
      setProgress(0)
    } catch (error) {
      if (error.status === 401) logout()
      toast.error(error?.response?.data?.message || "Upload failed.")
    }
  }

  const handleMultipleUpload = async (incomingFiles) => {
    for (const file of incomingFiles) {
      setFiles((prev) => [...prev, { file, isUploading: true }])
      await onUploadFile(file)
    }
  }

  const handleDeleteFile = (index) => {
    const updated = files.filter((_, i) => i !== index)
    setFiles(updated)
  }

  useEffect(() => {
    const areAllUploaded = files.every((item) => !item.isUploading)
    if (files.length > 0 && areAllUploaded) {
      onUploadSuccess(files)
    }
  }, [files])

  return (
    <>
      <Input
        type="file"
        accept=".pdf"
        multiple
        innerRef={fileRef}
        className="d-none"
        onChange={(e) => {
          const files = Array.from(e.target.files)
          if (files.length) handleMultipleUpload(files)
        }}
      />
      <div className="pdf-upload-wrapper">
        {files.map((fileObj, index) => (
          <>
            <div
              key={index}
              className="uploaded-document d-flex align-items-center gap-2 justify-content-between"
              style={{
                border: "1px solid #dcdcdc",
                borderRadius: "12px",
                padding: "12px 20px",
                marginBottom: "15px",
                position: "relative",
              }}
            >
              <div className="d-flex align-items-center gap-2 justify-content-start">
                <img src={checkboxIcon} alt="" />
                <div className="d-flex align-items-center gap-2">
                  <img src={pdfIcon} alt="" />
                  <div>
                    <h5
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "120px",
                      }}
                      title={fileObj.file.name}
                    >
                      {fileObj.file.name}
                    </h5>
                    <p>{fileSize(fileObj.file.size)}</p>
                  </div>
                </div>
              </div>

              <img
                className="cp"
                onClick={(e) => {
                  e.stopPropagation()
                  handleDeleteFile(index)
                }}
                src={deleteIcon}
                alt=""
              />

              {fileObj.isUploading && (
                <div
                  className="w-100 mt-2 theme-progress"
                  style={{
                    position: "absolute",
                    bottom: "8px",
                    left: "8px",
                    right: "0",
                    zIndex: "1",
                  }}
                >
                  <Progress
                    className="w-100"
                    value={progress || 0}
                    style={{ height: 5, maxWidth: "95%" }}
                  />
                </div>
              )}
            </div>
          </>
        ))}
      </div>
      <div
        className="upload-doc"
        onClick={() => fileRef.current.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault()
          const files = Array.from(e.dataTransfer.files)
          if (files.length) handleMultipleUpload(files)
        }}
      >
        <div className="text-center d-flex flex-column align-items-center gap-2 justify-content-center">
          <div className="upload-icon-wrapper">
            <img src={upload} alt="Upload" />
          </div>
          <h5>Click to upload or drag and drop</h5>
          <p>PDF files only</p>
        </div>
      </div>
    </>
  )
}

export default PdfUpload
